module.exports = __webpack_public_path__ + "img/txt.f88ea2bf.png";